import { fmtBRL } from "@/lib/api";
import { Receipt } from "@phosphor-icons/react";

// Card FINANCEIRO (Totais Marketplace) — visível apenas p/ admin
export default function FinancialCardMarketplace({ order }) {
  const t = order?.marketplace_totals || {};
  const has = t && Object.keys(t).length > 0;
  const values = has ? t : {
    input_base_taxa: order?.total_value || 0,
    input_taxa: 0,
    input_taxa_percentual: 0,
    custo_frete: order?.freight_value || 0,
    custo_frete_percentual: 0,
    total_comissao_percentual: 0,
    valor_liquido: order?.net_value || 0,
  };
  const fmtPct = (n) => `${(Number(n) || 0).toFixed(2).replace(".", ",")}%`;
  return (
    <div className="border border-black bg-white" data-testid="financial-card">
      <div className="border-b border-black p-4 flex items-center gap-2">
        <Receipt size={16} weight="bold" />
        <div className="overline text-zinc-500">FINANCEIRO — TOTAIS MARKETPLACE</div>
      </div>
      <div className="p-5 space-y-2 text-sm">
        <div className="flex justify-between">
          <span className="text-zinc-600">Valor do Anúncio</span>
          <span className="font-mono font-bold text-[#00A300]" data-testid="mkt-input-base-taxa">
            {fmtBRL(values.input_base_taxa)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-600">Taxa Mktplace</span>
          <span className="font-mono text-[#B58900]" data-testid="mkt-input-taxa">
            {fmtBRL(values.input_taxa)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-600">% Taxa Mktplace</span>
          <span className="font-mono text-[#B58900]" data-testid="mkt-input-taxa-pct">
            {fmtPct(values.input_taxa_percentual)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-600">Custo Frete</span>
          <span className="font-mono text-[#B58900]" data-testid="mkt-custo-frete">
            {fmtBRL(values.custo_frete)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-600">% Custo Frete</span>
          <span className="font-mono text-[#B58900]" data-testid="mkt-custo-frete-pct">
            {fmtPct(values.custo_frete_percentual)}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-600">Total de descontos</span>
          <span className="font-mono text-[#B58900]" data-testid="mkt-total-descontos">
            {fmtBRL(values.total_descontos ?? Math.max(0, (values.input_base_taxa || 0) - (values.valor_liquido || 0)))}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-zinc-600">% Total de descontos</span>
          <span className="font-mono text-[#B58900]" data-testid="mkt-total-desc-pct">
            {fmtPct(values.total_comissao_percentual)}
          </span>
        </div>
        <div className="flex justify-between bg-green-50 -mx-5 px-5 py-2 mt-2 border-t border-black">
          <span className="font-semibold text-[#00A300]">Total</span>
          <span className="font-mono font-bold text-[#00A300]" data-testid="mkt-valor-liquido">
            {fmtBRL(values.valor_liquido)}
          </span>
        </div>
        {!has && (
          <div className="text-[10px] text-zinc-400 italic pt-1">
            * Sem dados de marketplace ainda. Rode "Recompute Marketplace Totals" na manutenção.
          </div>
        )}
      </div>
    </div>
  );
}
